import { Injectable, inject } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { WidgetRegistryService } from '@frontend/sports/widget/core/feature';
import { OnFeatureInit } from '@frontend/vanilla/core';

import { MediaComponent } from './media.component';

@Injectable({ providedIn: 'root' })
export class MediaWidgetRegistration implements OnFeatureInit {
    private widgetRegistry = inject(WidgetRegistryService);

    onFeatureInit() {
        this.widgetRegistry.registerLazy(WidgetType.Media, MediaComponent);
    }
}
